"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useSearchParams } from "next/navigation";
import { useAgent } from "../../../../../../utils/agent/AgentProvider.js";
import { useState } from "react";
import { QuantitySelector } from "@nxt-costco-com/forge-components";
import ExtraCartMessage from "../../../../ExtraCartMessage/index.js";
import { useWcsToken } from "../../../../../../hooks/auth/useWcsToken/index.js";
import { buttonStyles } from "./styles.js";
const checkAddToCartError = (responseObj) => {
  var _a;
  const { orderErrMsgObj, errorMessage, customErrorLabel } = responseObj || {};
  return customErrorLabel || ((_a = Object.values(orderErrMsgObj || {})) == null ? void 0 : _a.join(". ")) || errorMessage;
};
const AddToCartButton = ({
  maxQuantity,
  contractIdentifier,
  itemNumber,
  minQuantity,
  partNumber,
  urls,
  addbtntext,
  decreasequantity,
  addtocartsuccessmessage,
  increasequantity,
  quantity,
  removeitemarialabel,
  removeitemerror,
  genericerror,
  productTitleId,
  refreshCartCallback
}) => {
  const [addToCartState, setAddToCartState] = useState();
  const { agent } = useAgent();
  useSearchParams();
  const { getTokenValue } = useWcsToken();
  const {
    response,
    qty = 0,
    isLoading,
    action,
    orderItem_id,
    orderId
  } = addToCartState || {};
  const customErrorMsg = checkAddToCartError(
    response
  );
  const getActionType = (updatedQty, type, orderId2) => {
    if (updatedQty === 0) {
      return "delete";
    }
    if (type === "add" || !orderId2) {
      return "add";
    }
    return "update";
  };
  const onQuantityChange = async (updatedQuantity, type) => {
    if (type === "change" || qty === updatedQuantity) return;
    const actionType = getActionType(updatedQuantity, type, orderId);
    if (type === "add" && !updatedQuantity) {
      updatedQuantity = 1;
    }
    const paramsObj = {
      "In-Cart": "in cart",
      actionType,
      ajaxFlag: true,
      checkOmsInventory: true,
      contractIdentifier,
      isQuickAddToCartButton: true,
      isRestrictedPostalCode: !!(localStorage == null ? void 0 : localStorage.getItem(
        "isRestrictedPostalCode"
      )),
      itemNumber,
      maxQuantity,
      minQuantity,
      partNumber,
      quantity: updatedQuantity,
      quantity_1: updatedQuantity
    };
    try {
      const authToken = await getTokenValue(true);
      setAddToCartState((prev) => {
        return {
          ...prev,
          action: "",
          isLoading: true
        };
      });
      const res = await (agent == null ? void 0 : agent.postAddToCartDetails(urls == null ? void 0 : urls.addToCartURL, {
        ...paramsObj,
        ...orderId && { orderId },
        ...type !== "add" && {
          orderItem_1: (response == null ? void 0 : response.orderItemId) || orderItem_id
        },
        authToken
      }));
      setAddToCartState((prev) => {
        return {
          ...prev,
          action: type,
          isLoading: false,
          orderId: !(prev == null ? void 0 : prev.orderId) ? res == null ? void 0 : res.orderId : prev.orderId,
          orderItem_id: !(prev == null ? void 0 : prev.orderItem_id) ? res == null ? void 0 : res.orderItemId : prev.orderItem_id,
          qty: res == null ? void 0 : res.itemMessage,
          response: updatedQuantity === 0 && checkAddToCartError(res) ? {
            ...res,
            customErrorLabel: removeitemerror
          } : res
        };
      });
      refreshCartCallback();
    } catch (error) {
      console.error("Add to cart post request failed:", error);
      setAddToCartState((prev) => {
        return {
          ...prev,
          action: "",
          isLoading: false,
          response: {
            customErrorLabel: genericerror
          }
        };
      });
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      QuantitySelector,
      {
        maxValue: !isNaN(Number(maxQuantity)) ? Number(maxQuantity) : void 0,
        minValue: !isNaN(Number(minQuantity)) ? Number(minQuantity) : void 0,
        action,
        addToCartLabel: addbtntext,
        customErrorMsg,
        decrementAriaLabel: decreasequantity,
        inCartLabel: addtocartsuccessmessage,
        incrementAriaLabel: increasequantity,
        isAddToCartVariant: true,
        isAddToCartVisible: +qty === 0,
        isLoading,
        onQuantityChange,
        parentUniqueId: productTitleId,
        quantityLabel: quantity,
        removeCartAriaLabel: removeitemarialabel,
        sx: buttonStyles,
        uniqueId: `ProductActions_${partNumber}`,
        updateQuantity: qty,
        showAddToCartPlusIcon: true
      }
    ),
    /* @__PURE__ */ jsx(ExtraCartMessage, { errorState: customErrorMsg, quantity: qty })
  ] });
};
export {
  AddToCartButton
};
